module.exports = __webpack_public_path__ + "static/media/Willow_Portrait.dc886ac1.png";